package com.hyperether.goodjob.repository.remote.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class EphemeralKeyRequest(
    @SerialName("customerId") var customerId: String? = null
)